RivalIQ.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.Link = Marionette.ItemView.extend({
        tagName: 'a',
        template: '#linkTemplate',
        events: {
            'click': 'onClick'
        },

        serializeData: function () {
            const me = this;
            const linkName = me.getOption('linkName');

            return {
                linkName: (_.isFunction(linkName) ? linkName.call(me) : linkName)
            };
        },

        onClick: function (e) {
            const me = this;
            const actionFn = me.getOption('action');
            if (actionFn) {
                e.preventDefault();
                actionFn.call(me);
            }
        }
    });
});
